import styles from './auth-page-header.module.css';
import { BrandLogo } from '../brand-logo/brand-logo';
import { useAppStore } from '../../store/app';

export const AuthPageHeader = () => {
  const { gameData } = useAppStore();
  const gameName = gameData?.name;
  return (
    <div className={styles.container}>
      <BrandLogo className={styles.logo} />
      {gameName && <div className={styles.gameName}>{gameName}</div>}
    </div>
  );
};
